import React from "react";

const StyledH5Heading = ({ children, font }) => {
  return (
    <h5 className={`text-h5 font-star-jedi lowercase ${font}`}>{children}</h5>
  );
};

export default StyledH5Heading;
